import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined';
import { Card } from '@components/atoms/Card';
import { Button } from '@components/atoms/Button';
import { ProjectStatusBadge } from '@components/atoms/ProjectStatusBadge';
import { StarToggle } from '@components/atoms/StarToggle';
import React from 'react';
import { Project } from '@models/project.model';
import { useTranslation } from '@hooks/useTranslation';

interface ActiveProjectCardProps {
  project: Project;
  onClick: (projectId: string) => void;
  onShowGeofence?: (project: Project) => void;
  onToggleFavorite?: (projectId: string) => void;
}

export const ActiveProjectCard: React.FC<ActiveProjectCardProps> = ({
  project,
  onClick,
  onShowGeofence,
  onToggleFavorite,
}) => {
  const tDashboard = useTranslation('dashboard');
  const handleClick = () => {
    if (project.projectId) {
      onClick(project.projectId);
    }
  };

  const handleGeofenceClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onShowGeofence?.(project);
  };

  return (
    <Card
      onClick={handleClick}
      className="flex gap-3 items-center cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md p-2"
      key={project.projectId}
    >
      {project?.siteImage ? (
        <img
          className="w-10 h-10 object-cover rounded-md flex-shrink-0"
          src={project.siteImage}
          alt={project.name}
        />
      ) : (
        <div className="w-10 h-10 bg-gray-200 text-gray-500 dark:bg-gray-600 rounded-md flex items-center justify-center flex-shrink-0">
          <ImageOutlinedIcon sx={{ fontSize: '18px' }} />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="text-sm truncate">{project.name}</div>
        {project.address && (
          <div className="text-xs text-gray-500 dark:text-gray-400 truncate">
            {project.address}
          </div>
        )}
      </div>
      {onToggleFavorite && project.projectId && (
        <StarToggle
          active={!!project.isFavorited}
          onToggle={() => onToggleFavorite(project.projectId as string)}
          size="sm"
        />
      )}
      {project.state && (
        <ProjectStatusBadge state={project.state} isBehind={project.isBehind} size="sm" />
      )}
      {onShowGeofence && (
        <Button
          variant="tertiary"
          onlyIcon
          onClick={handleGeofenceClick}
          title={tDashboard.viewGeofence}
        >
          <PinDropOutlinedIcon sx={{ fontSize: '16px' }} />
        </Button>
      )}
    </Card>
  );
};